export default function MySQL_CROSSJOIN() {
  return (
    <div>
      <h2>MySQL_CROSSJOIN</h2>    </div>
  );
}